import Nullstack from 'nullstack';
export default function IconCrane({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-crane",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 21h6"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-18l-6 6h18"
  }), "   ", Nullstack.element("path", {
    d: "M9 3l10 6"
  }), "   ", Nullstack.element("path", {
    d: "M17 9v4a2 2 0 1 1 -2 2"
  }), " ");
}